const DEVICE_ID_KEY = "nfh_device_id";

export function getDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}

/** Generate a fresh device_id and persist it, replacing the old one. */
export function rotateDeviceId(): string {
  const fresh = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_KEY, fresh);
  return fresh;
}

/**
 * Returns true when the server rejected the request because the
 * (phone, device_id) session row already exists in the database.
 */
export function isDuplicateDeviceSessionError(message: string): boolean {
  return (
    message.includes("duplicate key") && message.includes("device_session")
  );
}
